import React from 'react';
import { isNil } from 'lodash';
import {
  FinalFee,
  FinalFeeType,
  FinanceResponseData,
} from '@upstart/harmony/lib/legos/financingTypes';
import { Select } from '../../../../components/PencilEditor';
import { FeeItem } from './FeeItem';

const EmmisionFees = [
  {
    name: 'State Emissions Certification Fee',
    type: FinalFeeType.EMISSIONS_CERTIFICATION,
  },
  {
    name: 'State Emissions Exemption Fee',
    type: FinalFeeType.EMISSIONS_EXEMPTION,
  },
];
const NO_FEE_LABEL = 'None';
const NO_FEE_VALUE = '';

export function EmissionsFeeItem(props: {
  fee: FinalFee | undefined;
  responseData?: FinanceResponseData;
  onChange: (data: Partial<FinanceResponseData>) => void;
  required?: boolean;
}) {
  const { responseData, fee, onChange, required } = props;

  return (
    <FeeItem
      isValueDisabled={isNil(fee)}
      description={
        <Select
          value={fee?.type ?? NO_FEE_VALUE}
          required={required}
          onChange={(newType: FinalFeeType | typeof NO_FEE_VALUE) => {
            const currentList = responseData?.finalizedFeeList ?? [];
            let finalizedFeeList = currentList.filter(
              (finalizedFee) =>
                !EmmisionFees.map((f) => f.type).includes(finalizedFee.type),
            );
            if (newType) {
              const newFee = { type: newType, value: fee?.value ?? 0 };
              finalizedFeeList = finalizedFeeList.concat(newFee);
            }
            onChange({ finalizedFeeList });
          }}
        >
          <Select.Option
            key={NO_FEE_LABEL}
            name={NO_FEE_LABEL}
            value={NO_FEE_VALUE}
          />
          {EmmisionFees.map((f) => (
            <Select.Option key={f.name} name={f.name} value={f.type} />
          ))}
        </Select>
      }
      {...props}
      fee={
        fee || {
          value: 0,
          type: FinalFeeType.EMISSIONS_CERTIFICATION,
        }
      }
    />
  );
}

export default EmissionsFeeItem;
